// extracted by mini-css-extract-plugin
export default {"edit":"Icons_edit__-CH2E","confirm":"Icons_confirm__GytLj"};